/** Lead routing dialog (Leads → Lead routing), engage group. */
export const routing = {
  open: "Lead routing",
  title: "Lead routing",
  subtitle: "Who new leads go to, and where lead emails are sent.",
  loadError: "Lead routing couldn't load.",
  mode: {
    label: "Assign new leads",
    round_robin: "Round-robin",
    round_robinHint: "Spread new leads evenly across active teammates who can edit leads.",
    default_owner: "Always the same person",
    default_ownerHint: "Every new lead goes to one teammate. If they leave or lose access, round-robin takes over.",
  },
  owner: {
    label: "Default owner",
    placeholder: "Choose a teammate",
    required: "Choose who new leads go to.",
  },
  email: {
    label: "Shared leads inbox",
    optional: "(optional)",
    hint: "This address also gets the “New lead” email, for example leads@yourschool.ph.",
    placeholder: "leads@example.ph",
    invalid: "Enter a valid email address.",
  },
  readOnly: "You can see how leads are routed. Changing it needs permission to edit leads.",
  save: "Save routing",
  saved: "Lead routing saved",
} as const;
